import { createSelector } from "reselect";
import getElementStatusFilter from "./get_element_status_filter";

const getNotBuiltElementsShown = createSelector([
  getElementStatusFilter
], (filter) => filter.notBuiltElementsShown);

export default getNotBuiltElementsShown;
